import { render, staticRenderFns } from "./DialogAddArticleCheck.vue?vue&type=template&id=174cd658&scoped=true"
import script from "./DialogAddArticleCheck.vue?vue&type=script&lang=js"
export * from "./DialogAddArticleCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174cd658",
  null
  
)

export default component.exports